import { Component, Output, EventEmitter, Input, ViewChild , CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA} from "@angular/core";
import { CommonModule } from "@angular/common";
import { ModalDirective } from "../../directives/modal.directive";
import { AppSettings } from "../../appsettings";

@Component({
    selector: "confirmationcountrydialogmodal",
    templateUrl: "./confirmationcountrydialogmodal.component.html",
    standalone: true,
    imports: [CommonModule, ModalDirective],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class ConfirmationCountryModalComponent {
    @Output() onAccept = new EventEmitter();
    @Output() onDecline = new EventEmitter();
    @Input() confirmationText: string = "";
    loaded: boolean = false;
    config: any = {};
    @ViewChild("confirmationcountrydialogmodal") public confirmationcountrydialogmodal: ModalDirective;

    constructor() {
        if (this.confirmationText === "") {
            this.confirmationText = AppSettings.pendingChangeText;
        }
    }

    /**
     * Emits the change to the caller and closes the modal
     */
    onClick(accept: boolean): void {
        if (accept) {
            this.onAccept.emit();
        } else {
            this.onDecline.emit();
        }
        this.confirmationcountrydialogmodal.hide();
    }

    openModal(): void {
        this.confirmationcountrydialogmodal.show();
    }
    closeModal(): void {
        this.confirmationcountrydialogmodal.hide();
    }
}


